import { CustomIcon, EIconName } from '@ppmcore/seven-ppm-core-shared-components-react';
import React, { forwardRef, useImperativeHandle } from 'react';

// Styles
import './options-list.scss';

type TOptionsListProps = {
  options: { id: number, name: string }[];
  selectedList: number[];
  loading?: boolean;
  onSelectItem?: (ids: number[]) => void;
}

type TComponentHandle = {
  resetOptionList: () => void;
}

export const OptionsList = forwardRef<TComponentHandle, TOptionsListProps>(
  ({ options, loading, selectedList, onSelectItem = () => {} }: TOptionsListProps, ref
  ) => {

    useImperativeHandle(ref, () => ({
      resetOptionList() {
        // something action
      },
    }));

    const selectOption = (id: number): void => {
      onSelectItem(selectedList.includes(id) ? [] : [id]);
    }

    return (
      <div className="options-list">

        {
          options.map(({ id, name }) => (
            <div key={ id } className={ `options-list--item` }
                 onClick={ () => selectOption(id) }>
              <div className="item-text">
                { name }
              </div>
              { selectedList.includes(id) && <div className="item-icon">
                <CustomIcon name={ EIconName.Check_outline_none }/>
              </div> }
            </div>
          ))
        }
      </div>
    );
  }
)
